var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaNewLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 252,
    viewBox: "0 0 173 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7892 0.242188C26.5462 0.242188 0.40625 25.5662 0.40625 56.8023C0.40625 74.373 9.64523 89.041 21.6492 100.446C50.3692 127.731 52.8722 111.222 58.7892 251.432C64.7062 111.222 67.2082 127.731 95.9282 100.446C107.932 89.026 117.171 74.373 117.171 56.8023C117.171 25.5662 91.0312 0.242188 58.7892 0.242188Z",
    fill: "url(#paint0_linear_309_137)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M106.905 67.641C112.503 41.8867 95.4886 16.6128 68.9046 11.1903C42.3206 5.76774 16.2326 22.2497 10.6356 48.0041C5.0386 73.7587 22.0516 99.0327 48.6356 104.455C75.2196 109.878 101.308 93.3957 106.905 67.641Z",
    fill: "url(#paint1_linear_309_137)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7847 99.743C82.6837 99.743 102.058 80.974 102.058 57.8209C102.058 34.6678 82.6837 15.8984 58.7847 15.8984C34.8857 15.8984 15.5117 34.6678 15.5117 57.8209C15.5117 80.974 34.8857 99.743 58.7847 99.743Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_137",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 38,
    width: 43,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38H39V71H82V38Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 38H82V49H39V38Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 49H82V60H39V49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 60H82V71H39V60Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4993 58.8996C62.8743 58.8996 64.7993 56.9297 64.7993 54.4996C64.7993 52.0696 62.8743 50.0996 60.4993 50.0996C58.1243 50.0996 56.1992 52.0696 56.1992 54.4996C56.1992 56.9297 58.1243 58.8996 60.4993 58.8996Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5013 58.3504C62.5793 58.3504 64.2633 56.6267 64.2633 54.5004C64.2633 52.3741 62.5793 50.6504 60.5013 50.6504C58.4233 50.6504 56.7383 52.3741 56.7383 54.5004C56.7383 56.6267 58.4233 58.3504 60.5013 58.3504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.502 55.2705C60.918 55.2705 61.255 54.9257 61.255 54.5005C61.255 54.0752 60.918 53.7305 60.502 53.7305C60.087 53.7305 59.75 54.0752 59.75 54.5005C59.75 54.9257 60.087 55.2705 60.502 55.2705Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2038 55.199C64.3098 55.2133 64.4069 55.137 64.4209 55.0285C64.4349 54.9201 64.3599 54.8207 64.2539 54.8064C64.1479 54.7921 64.0508 54.8684 64.0368 54.9769C64.0228 55.0853 64.0978 55.1847 64.2038 55.199Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5001 58.3495L60.6292 56.0395L60.5001 54.9395L60.3711 56.0395L60.5001 58.3495Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9058 56.1572C64.0048 56.1994 64.1178 56.1521 64.1588 56.0515C64.1988 55.9509 64.1519 55.8351 64.0529 55.7928C63.9529 55.7506 63.8398 55.7979 63.7998 55.8985C63.7588 55.9991 63.8068 56.1149 63.9058 56.1572Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5312 58.2182L60.2392 56.0227L60.3892 54.9258L59.9862 55.953L59.5312 58.2182Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3691 57.0026C63.4551 57.0696 63.5761 57.0539 63.6411 56.9676C63.7051 56.8813 63.6891 56.757 63.6041 56.69C63.5181 56.623 63.3971 56.6386 63.3321 56.7249C63.2681 56.8113 63.2841 56.9356 63.3691 57.0026Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.625 57.8343L59.865 55.9018L60.289 54.8828L59.639 55.7681L58.625 57.8343Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6419 57.6754C62.7069 57.7625 62.8289 57.7795 62.9129 57.7134C62.9979 57.6472 63.013 57.5229 62.948 57.4357C62.882 57.3486 62.7609 57.3316 62.6759 57.3978C62.5919 57.464 62.5769 57.5882 62.6419 57.6754Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8438 57.222L59.5308 55.6839L60.1987 54.8125L59.3467 55.4955L57.8438 57.222Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7564 58.1336C61.7964 58.2341 61.9104 58.2813 62.0094 58.239C62.1084 58.1967 62.1565 58.0808 62.1155 57.9803C62.0755 57.8797 61.9624 57.8325 61.8624 57.8749C61.7634 57.9172 61.7164 58.033 61.7564 58.1336Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2383 56.4264L59.2573 55.3826L60.1252 54.7188L59.1302 55.1566L57.2383 56.4264Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7944 58.3431C60.8084 58.4511 60.9055 58.5266 61.0115 58.5118C61.1185 58.4971 61.1935 58.3976 61.1805 58.2897C61.1665 58.1817 61.0694 58.1062 60.9634 58.121C60.8564 58.1357 60.7814 58.2352 60.7944 58.3431Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8633 55.4959L59.0773 55.021L60.0843 54.6094L59.0123 54.7698L56.8633 55.4959Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8144 58.2891C59.7994 58.398 59.8734 58.4975 59.9784 58.5112C60.0844 58.525 60.1815 58.4479 60.1965 58.339C60.2105 58.2301 60.1364 58.1306 60.0314 58.1168C59.9254 58.1031 59.8284 58.1802 59.8144 58.2891Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7344 54.5059L58.9904 54.6189L60.0654 54.4897L58.9914 54.3711L56.7344 54.5059Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8781 57.9802C58.8371 58.0815 58.8841 58.1974 58.9821 58.239C59.0811 58.2806 59.1941 58.2323 59.2351 58.1311C59.2761 58.0298 59.2301 57.914 59.1311 57.8724C59.0331 57.8308 58.9191 57.879 58.8781 57.9802Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8633 53.502L59.0103 54.227L60.0813 54.3825L59.0773 53.97L56.8633 53.502Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0591 57.4339C57.9941 57.5202 58.0111 57.6445 58.0961 57.7115C58.1811 57.7785 58.3031 57.7629 58.3671 57.6766C58.4321 57.5903 58.4151 57.466 58.3301 57.399C58.2451 57.332 58.1231 57.3476 58.0591 57.4339Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2422 52.5742L59.1342 53.844L60.1302 54.2819L59.2621 53.618L57.2422 52.5742Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3947 56.6867C57.3107 56.7529 57.2957 56.8772 57.3607 56.9644C57.4267 57.0516 57.5477 57.0687 57.6317 57.0025C57.7167 56.9364 57.7317 56.8121 57.6667 56.7249C57.6007 56.6377 57.4797 56.6206 57.3947 56.6867Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8398 51.7793L59.3478 53.5064L60.1988 54.1926L59.5278 53.3218L57.8398 51.7793Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.951 55.7883C56.852 55.8298 56.806 55.9457 56.847 56.047C56.889 56.1484 57.002 56.1969 57.1 56.1554C57.199 56.1139 57.245 55.9981 57.204 55.8967C57.162 55.7954 57.049 55.7468 56.951 55.7883Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6211 51.166L59.6401 53.2327L60.2891 54.1203L59.8611 53.1019L58.6211 51.166Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7448 54.8024C56.6398 54.8164 56.5658 54.9158 56.5798 55.0246C56.5938 55.1334 56.6908 55.2102 56.7968 55.1963C56.9028 55.1824 56.9768 55.0829 56.9618 54.9741C56.9478 54.8654 56.8508 54.7885 56.7448 54.8024Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5273 50.7793L59.9904 53.0449L60.3924 54.074L60.2374 52.9775L59.5273 50.7793Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7929 53.8007C56.6859 53.7859 56.5889 53.8614 56.5759 53.9694C56.5619 54.0773 56.6369 54.1768 56.7439 54.1915C56.8499 54.2063 56.9468 54.1308 56.9608 54.0228C56.9738 53.9149 56.8989 53.8154 56.7929 53.8007Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4938 50.6504L60.3828 52.9588L60.5098 54.0591L60.6259 52.9602L60.4938 50.6504Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0954 52.8416C56.9964 52.7994 56.8834 52.8467 56.8424 52.9473C56.8024 53.0479 56.8493 53.1637 56.9483 53.206C57.0483 53.2482 57.1614 53.2009 57.2014 53.1003C57.2424 52.9997 57.1944 52.8839 57.0954 52.8416Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4713 50.7812L60.7633 52.9768L60.6133 54.0737L61.0163 53.0465L61.4713 50.7812Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6348 52.0006C57.5498 51.9336 57.4288 51.9492 57.3638 52.0355C57.2988 52.1218 57.3158 52.2461 57.4008 52.3131C57.4868 52.3802 57.6078 52.3645 57.6728 52.2782C57.7368 52.1919 57.7208 52.0676 57.6348 52.0006Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3828 51.168L61.1428 53.1006L60.7188 54.1195L61.3688 53.2343L62.3828 51.168Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.362 51.3265C58.296 51.2393 58.175 51.2222 58.09 51.2883C58.006 51.3544 57.991 51.4787 58.056 51.5659C58.122 51.6531 58.243 51.6702 58.328 51.6041C58.412 51.538 58.427 51.4137 58.362 51.3265Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1597 51.7793L61.4727 53.3171L60.8047 54.1886L61.6567 53.5057L63.1597 51.7793Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2448 50.8671C59.2048 50.7665 59.0908 50.7193 58.9918 50.7617C58.8928 50.804 58.8448 50.9198 58.8858 51.0204C58.9258 51.1209 59.0388 51.1681 59.1388 51.1258C59.2378 51.0835 59.2848 50.9676 59.2448 50.8671Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.762 52.5762L61.743 53.6201L60.875 54.2839L61.87 53.846L63.762 52.5762Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2039 50.6569C60.1899 50.5489 60.0929 50.4734 59.9869 50.4882C59.8799 50.5029 59.8049 50.6024 59.8179 50.7103C59.8319 50.8183 59.9289 50.8938 60.0349 50.879C60.1419 50.8643 60.2169 50.7648 60.2039 50.6569Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1351 53.5039L61.921 53.9788L60.9141 54.3904L61.986 54.23L64.1351 53.5039Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1837 50.7101C61.1987 50.6011 61.1247 50.5016 61.0197 50.4879C60.9137 50.4742 60.8167 50.5514 60.8027 50.6604C60.7877 50.7694 60.8617 50.8688 60.9667 50.8826C61.0727 50.8963 61.1697 50.819 61.1837 50.7101Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2607 54.4915L62.0057 54.3809L60.9297 54.5097L62.0037 54.6268L64.2607 54.4915Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1181 51.0196C62.1591 50.9183 62.1121 50.8026 62.0141 50.761C61.9151 50.7195 61.8021 50.7679 61.7611 50.8693C61.7201 50.9706 61.7661 51.0863 61.8651 51.1279C61.9631 51.1694 62.0761 51.121 62.1181 51.0196Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.136 55.4949L61.99 54.7701L60.918 54.6152L61.922 55.0279L64.136 55.4949Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9483 51.5643C63.0133 51.4773 62.9983 51.353 62.9133 51.2867C62.8283 51.2203 62.7073 51.237 62.6423 51.324C62.5763 51.411 62.5923 51.5353 62.6773 51.6016C62.7613 51.668 62.8833 51.6513 62.9483 51.5643Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7649 56.4244L61.8749 55.1553L60.8789 54.7207L61.7449 55.3853L63.7649 56.4244Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6045 52.3136C63.6895 52.2468 63.7056 52.1225 63.6406 52.036C63.5756 51.9494 63.4546 51.9334 63.3696 52.0002C63.2846 52.067 63.2675 52.1913 63.3325 52.2779C63.3975 52.3644 63.5195 52.3804 63.6045 52.3136Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1636 57.2208L61.6596 55.4942L60.8086 54.8105L61.4766 55.6819L63.1636 57.2208Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0524 53.2105C64.1514 53.1684 64.1984 53.0526 64.1584 52.9518C64.1174 52.851 64.0044 52.8033 63.9054 52.8454C63.8064 52.8875 63.7594 53.0033 63.7994 53.1041C63.8404 53.2049 63.9534 53.2525 64.0524 53.2105Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3837 57.8352L61.3677 55.7688L60.7188 54.8828L61.1437 55.9016L62.3837 57.8352Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2585 54.1964C64.3645 54.1819 64.4395 54.0824 64.4255 53.9742C64.4115 53.866 64.3146 53.79 64.2086 53.8045C64.1026 53.819 64.0275 53.9185 64.0405 54.0267C64.0545 54.1349 64.1515 54.2108 64.2585 54.1964Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4772 58.219L61.0202 55.9536L60.6172 54.9258L60.7692 56.0226L61.4772 58.219Z",
    fill: "#000088"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.134 12V25H123V12H126.134ZM139.914 25H136.78L131.538 16.9815V25H128.405V12H131.538L136.78 20.0556V12H139.914V25ZM147.004 12C148.36 12 149.546 12.2716 150.56 12.8148C151.574 13.358 152.355 14.1235 152.905 15.1111C153.467 16.0864 153.748 17.216 153.748 18.5C153.748 19.7716 153.467 20.9012 152.905 21.8889C152.355 22.8765 151.568 23.642 150.541 24.1852C149.527 24.7284 148.348 25 147.004 25H142.185V12H147.004ZM146.803 22.2593C147.988 22.2593 148.91 21.9321 149.57 21.2778C150.23 20.6235 150.56 19.6975 150.56 18.5C150.56 17.3025 150.23 16.3704 149.57 15.7037C148.91 15.037 147.988 14.7037 146.803 14.7037H145.318V22.2593H146.803ZM158.634 12V25H155.5V12H158.634ZM168.913 22.7037H164.112L163.342 25H160.062L164.717 12H168.345L173 25H169.683L168.913 22.7037ZM168.107 20.2593L166.513 15.5L164.937 20.2593H168.107Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_137",
    x1: -16.6028,
    y1: 102.212,
    x2: 94.7953,
    y2: 137.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D22C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BA1916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#901916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#851916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_309_137",
    x1: 23.9836,
    y1: 24.1376,
    x2: 91.3306,
    y2: 93.6697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FF765F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF765F",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF765F",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF765F",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF765F",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FF765F",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF765F",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF765F",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF765F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaNewLoc);
export default __webpack_public_path__ + "static/media/India_new_loc.8e4d4c430c017e6053c45c0762b4f925.svg";
export { ForwardRef as ReactComponent };